"use client";

import * as React from "react";
import { ArrowUpRight, Cake, Heart, Sparkles, X } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
type Cake = {
  id: number;
  title: string;
  occasion: string;
  occasionKey: string;
  style: string;
  flavor: string;
  serves: string;
  testimonial: string;
  client: string;
  src: string;
  srcset: string;
  sizes: string;
  alt: string;
  ratio: string;
};
const cakes: Cake[] = [{
  id: 1,
  title: "ویلا مدرن لواسان",
  occasion: "مسکونی",
  occasionKey: "residential",
  style: "modern",
  flavor: "طراحی مینیمال با متریال بتن و چوب",
  serves: "متراژ ۴۵۰ متر",
  testimonial: "آرتین توانست فضایی خلق کند که همزمان مدرن و بسیار گرم و صمیمی است. هر گوشه از خانه داستان خودش را دارد.",
  client: "خانواده راد",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/villa_lavasan.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/villa_lavasan.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/villa_lavasan.webp-wvc-sizes",
  alt: "نمای داخلی ویلای مدرن با نورپردازی هوشمند",
  ratio: "aspect-[3/4]"
}, {
  id: 2,
  title: "کافه هنری مرکز",
  occasion: "تجاری",
  occasionKey: "commercial",
  style: "industrial",
  flavor: "ترکیب فلز و گیاهان طبیعی",
  serves: "ظرفیت ۶۰ نفر",
  testimonial: "طراحی استودیو آرتین باعث شد کافه ما به پاتوق اصلی هنرمندان شهر تبدیل شود. جزئیات بی‌نظیر است.",
  client: "مدیریت کافه گالری",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/cafe_art.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/cafe_art.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/cafe_art.png-wvc-sizes",
  alt: "طراحی داخلی کافه با سبک صنعتی و نورپردازی گرم",
  ratio: "aspect-square"
}, {
  id: 3,
  title: "آپارتمان کلاسیک",
  occasion: "مسکونی",
  occasionKey: "residential",
  style: "classic",
  flavor: "استفاده از سنگ مرمر و گچ‌بری‌های ظریف",
  serves: "متراژ ۲۰۰ متر",
  testimonial: "تجربه‌ای فوق‌العاده از یک بازسازی کامل. آرتین به تمام خواسته‌های ما با دقت گوش داد.",
  client: "دکتر و خانم علوی",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/classic_apartment.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/classic_apartment.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/classic_apartment.png-wvc-sizes",
  alt: "فضای نشیمن کلاسیک با جزئیات لوکس",
  ratio: "aspect-[4/5]"
}, {
  id: 4,
  title: "دفتر کار خلاق",
  occasion: "تجاری",
  occasionKey: "commercial",
  style: "modern",
  flavor: "فضای باز با مبلمان ارگونومیک",
  serves: "ظرفیت ۳۰ نفر",
  testimonial: "بهره‌وری تیم ما بعد از تغییر دکوراسیون توسط آرتین به شدت افزایش یافت. محیطی الهام‌بخش است.",
  client: "استودیو طراحی دیجیتال",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/creative_office.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/creative_office.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/creative_office.webp-wvc-sizes",
  alt: "دفتر کار مدرن با طراحی باز و نور طبیعی",
  ratio: "aspect-[3/4]"
}, {
  id: 5,
  title: "پنت‌هاوس الهیه",
  occasion: "مسکونی",
  occasionKey: "residential",
  style: "luxury",
  flavor: "پالت رنگی خنثی با اکسسوری‌های برنزی",
  serves: "متراژ ۶۰۰ متر",
  testimonial: "آرتین فراتر از یک طراح، یک هنرمند است. این خانه اکنون نماد آرامش ماست.",
  client: "جناب آقای مهندس",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/penthouse_elahiye.webp",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/penthouse_elahiye.webp-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/penthouse_elahiye.webp-wvc-sizes",
  alt: "پنت‌هاوس لوکس با دید پانوراما",
  ratio: "aspect-square"
}, {
  id: 6,
  title: "بوتیک لباس",
  occasion: "تجاری",
  occasionKey: "commercial",
  style: "minimal",
  flavor: "قفسه‌های معلق و نورپردازی تاکیدی",
  serves: "متراژ ۱۰۰ متر",
  testimonial: "مشتریان ما عاشق فضای بوتیک هستند. آرتین به خوبی می‌داند چگونه فضا را برای فروش بهینه کند.",
  client: "برند مد پارسی",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/fashion_boutique.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/fashion_boutique.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/fashion_boutique.png-wvc-sizes",
  alt: "بوتیک لباس با طراحی مینیمال و مدرن",
  ratio: "aspect-[4/5]"
}, {
  id: 7,
  title: "خانه باغ لواسان",
  occasion: "مسکونی",
  occasionKey: "residential",
  style: "rustic",
  flavor: "چوب طبیعی و سنگ‌های رودخانه‌ای",
  serves: "متراژ ۳۰۰ متر",
  testimonial: "حس طبیعت را به داخل خانه آورد. آرتین درک عمیقی از معماری همساز با اقلیم دارد.",
  client: "خانواده کیانی",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/garden_house.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/garden_house.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/garden_house.png-wvc-sizes",
  alt: "خانه باغ با متریال طبیعی و گرم",
  ratio: "aspect-[3/4]"
}, {
  id: 8,
  title: "رستوران سنتی مدرن",
  occasion: "تجاری",
  occasionKey: "commercial",
  style: "fusion",
  flavor: "کاشی‌کاری‌های ایرانی با مبلمان مدرن",
  serves: "ظرفیت ۱۰۰ نفر",
  testimonial: "ترکیب سنت و مدرنیته در این رستوران خیره‌کننده است. آرتین به میراث ما احترام گذاشت.",
  client: "مجموعه غذایی اصیل",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/fusion_restaurant.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/fusion_restaurant.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/fusion_restaurant.png-wvc-sizes",
  alt: "رستوران با طراحی تلفیقی سنتی و مدرن",
  ratio: "aspect-square"
}, {
  id: 9,
  title: "استودیو شخصی",
  occasion: "مسکونی",
  occasionKey: "residential",
  style: "modern",
  flavor: "نورپردازی هوشمند و آکوستیک حرفه‌ای",
  serves: "متراژ ۵۰ متر",
  testimonial: "فضایی که آرتین برای من ساخت، خلاقیت مرا دوچندان کرد. بسیار کاربردی و زیبا.",
  client: "هنرمند نقاش",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/personal_studio.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/personal_studio.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705125/img/personal_studio.png-wvc-sizes",
  alt: "استودیو هنری با نورپردازی دقیق",
  ratio: "aspect-[4/5]"
}];
const occasionFilters = [{
  label: "همه",
  value: "all"
}, {
  label: "مسکونی",
  value: "residential"
}, {
  label: "تجاری",
  value: "commercial"
}];
const styleFilters = [{
  label: "همه سبک‌ها",
  value: "all"
}, {
  label: "مدرن",
  value: "modern"
}, {
  label: "کلاسیک",
  value: "classic"
}, {
  label: "مینیمال",
  value: "minimal"
}, {
  label: "صنعتی",
  value: "industrial"
}, {
  label: "لوکس",
  value: "luxury"
}];
export default function Portfolio() {
  const [occasion, setOccasion] = React.useState<string>("all");
  const [style, setStyle] = React.useState<string>("all");
  const [selected, setSelected] = React.useState<Cake | null>(null);
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: filtersRef,
    isVisible: filtersVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.05
  });
  const {
    ref: footerRef,
    isVisible: footerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const filtered = cakes.filter(c => {
    const okOccasion = occasion === "all" || c.occasionKey === occasion;
    const okStyle = style === "all" || c.style === style;
    return okOccasion && okStyle;
  });
  return <section data-section-id="160" id="آرشیو-فضاهای-ماندگار" className="bg-background py-24 md:py-[120px] text-foreground">
      <div className="mx-auto max-w-7xl px-6 md:px-10">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 gap-10 md:grid-cols-12 md:gap-12 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="md:col-span-7">
            <div className="flex items-center gap-3">
              <span className="h-px w-10 bg-foreground/30" />
              <span className="font-mono text-xs tracking-[0.3em] uppercase text-muted-foreground">
                آرشیو پروژه‌ها
              </span>
            </div>
            <h2 className="mt-6 font-default font-serif text-4xl leading-[1.05] tracking-tight text-foreground md:text-[56px]">
              طراحی فضاهایی برای{" "}
              <em className="font-serif italic font-light text-accent-foreground">
                تجربه‌های ماندگار.
              </em>
            </h2>
          </div>
          <div className="md:col-span-5 md:pt-6">
            <p className="font-default text-base leading-relaxed text-muted-foreground md:text-lg">
              هر پروژه در استودیو آرتین، روایتی است از ترکیب هنر و مهندسی. ما با درک عمیق از سبک زندگی شما، فضاهایی خلق می‌کنیم که نه تنها زیبا، بلکه بازتابی از هویت و نیازهای شما هستند.
            </p>
          </div>
        </div>

        {}
        <div ref={filtersRef} className={`mt-14 space-y-5 transition-all duration-1000 delay-150 ease-out ${filtersVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground shrink-0 sm:w-24">
              کاربری
            </span>
            <div className="flex flex-wrap gap-2">
              {occasionFilters.map((f, i) => <Button key={f.value} data-index={i} variant="ghost" size="sm" onClick={() => setOccasion(f.value)} className={`rounded-none border px-4 py-2 h-auto font-default text-sm transition-colors ${occasion === f.value ? "border-foreground bg-foreground text-background hover:bg-foreground/90 hover:text-background" : "border-border bg-transparent text-foreground hover:bg-muted hover:text-foreground"}`}>
                  {f.label}
                </Button>)}
            </div>
          </div>

          <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <span className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground shrink-0 sm:w-24">
              سبک
            </span>
            <div className="flex flex-wrap gap-2">
              {styleFilters.map((f, i) => <Button key={f.value} data-index={i} variant="ghost" size="sm" onClick={() => setStyle(f.value)} className={`rounded-none border px-4 py-2 h-auto font-default text-sm transition-colors ${style === f.value ? "border-foreground bg-foreground text-background hover:bg-foreground/90 hover:text-background" : "border-border bg-transparent text-foreground hover:bg-muted hover:text-foreground"}`}>
                  {f.label}
                </Button>)}
            </div>
          </div>
        </div>

        {}
        <div ref={gridRef} className={`mt-14 transition-all duration-1000 delay-300 ease-out ${gridVisible ? "opacity-100" : "opacity-0"}`}>
          {filtered.length === 0 ? <div className="flex flex-col items-center justify-center border border-dashed border-border py-20 text-center">
              <Cake className="h-8 w-8 text-muted-foreground" />
              <p className="mt-4 font-default font-serif text-xl text-foreground">
                پروژه‌ای با این مشخصات یافت نشد.
              </p>
              <p className="mt-2 font-default text-sm text-muted-foreground">
                لطفاً فیلترهای دیگری را امتحان کنید.
              </p>
            </div> : <div className="columns-1 gap-4 sm:columns-2 lg:columns-3 [column-fill:_balance]">
              {filtered.map((cake, i) => <div key={cake.id} data-index={i} className="mb-4 break-inside-avoid">
                  <Button onClick={() => setSelected(cake)} variant="ghost" className="group relative h-auto w-full overflow-hidden bg-muted p-0 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-ring" aria-label={`مشاهده جزئیات ${cake.title}`}>
                    <div className={`relative w-full ${cake.ratio}`}>
                      <img src={cake.src} data-wvc-srcset={cake.srcset} data-wvc-sizes={cake.sizes} alt={cake.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" />
                      <div className="absolute inset-0 flex flex-col justify-end bg-background/85 p-6 opacity-0 transition-opacity duration-500 ease-out group-hover:opacity-100">
                        <Badge variant="outline" className="self-start border-foreground/20 bg-background/60 font-mono text-[10px] tracking-[0.2em] uppercase text-foreground">
                          {cake.occasion}
                        </Badge>
                        <h3 className="mt-3 font-default font-serif text-2xl leading-tight text-foreground">
                          {cake.title}
                        </h3>
                        <div className="mt-4 flex items-center justify-between">
                          <span className="font-default text-sm text-muted-foreground">
                            مشاهده جزئیات
                          </span>
                          <span className="flex h-9 w-9 items-center justify-center border border-foreground/20 text-foreground transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1">
                            <ArrowUpRight className="h-4 w-4" />
                          </span>
                        </div>
                      </div>
                    </div>
                  </Button>
                </div>)}
            </div>}
        </div>

        {}
        <div ref={footerRef} className={`mt-20 flex flex-col items-center justify-center text-center transition-all duration-1000 ease-out ${footerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center gap-2 text-muted-foreground">
            <Sparkles className="h-4 w-4" />
            <p className="font-default font-serif italic text-lg md:text-xl text-foreground/80">
              آیا به دنبال طراحی فضای اختصاصی خود هستید؟
            </p>
          </div>
          <Button variant="outline" size="lg" className="mt-6 border-foreground bg-transparent px-7 text-foreground hover:bg-foreground hover:text-background">
            <Heart className="h-4 w-4" />
            مشاوره طراحی
          </Button>
        </div>
      </div>

      {}
      <Dialog open={selected !== null} onOpenChange={open => !open && setSelected(null)}>
        <DialogContent showCloseButton={false} className="max-w-5xl overflow-hidden bg-background p-0">
          {selected && <div className="grid grid-cols-1 md:grid-cols-2">
              <div className="relative bg-muted">
                <img src={selected.src} data-wvc-srcset={selected.srcset} data-wvc-sizes={selected.sizes} alt={selected.alt} loading="lazy" className="h-full max-h-[70vh] w-full object-cover md:max-h-none" />
              </div>
              <div className="relative flex flex-col p-8 md:p-10">
                <Button variant="ghost" size="icon" onClick={() => setSelected(null)} className="absolute top-4 right-4 h-9 w-9 text-foreground hover:bg-muted" aria-label="بستن">
                  <X className="h-4 w-4" />
                </Button>

                <Badge variant="outline" className="self-start border-foreground/20 font-mono text-[10px] tracking-[0.2em] uppercase text-foreground">
                  {selected.occasion}
                </Badge>

                <DialogTitle className="mt-5 font-default font-serif text-3xl leading-tight text-foreground md:text-4xl">
                  {selected.title}
                </DialogTitle>

                <div className="mt-8 space-y-5">
                  <div>
                    <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground">
                      ویژگی‌ها
                    </p>
                    <p className="mt-1 font-default text-base text-foreground">
                      {selected.flavor}
                    </p>
                  </div>
                  <div>
                    <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground">
                      مشخصات
                    </p>
                    <p className="mt-1 font-default text-base text-foreground">
                      {selected.serves}
                    </p>
                  </div>
                  <div>
                    <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-muted-foreground">
                      سبک
                    </p>
                    <p className="mt-1 font-default text-base capitalize text-foreground">
                      {selected.style}
                    </p>
                  </div>
                </div>

                <div className="mt-8 border-t border-border pt-6">
                  <p className="font-default font-serif text-lg italic leading-relaxed text-foreground/90">
                    &ldquo;{selected.testimonial}&rdquo;
                  </p>
                  <p className="mt-3 font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground">
                    — {selected.client}
                  </p>
                </div>

                <div className="mt-auto pt-8">
                  <Button size="lg" className="w-full bg-foreground text-background hover:bg-foreground/90 sm:w-auto">
                    <Heart className="h-4 w-4" />
                    شروع همکاری
                  </Button>
                </div>
              </div>
            </div>}
        </DialogContent>
      </Dialog>
    </section>;
}